import './TagChip.css';

function TagChip({ id, label, selected = false, onToggle, disabled = false }) {
  return (
    <button
      type="button"
      className={`TagChip${selected ? ' TagChip--selected' : ''}`}
      onClick={() => onToggle({ id, label })}
      aria-pressed={selected}
      disabled={disabled}
    >
      <span className="TagChip-label">{label}</span>
    </button>
  );
}

export default TagChip;
